var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/common/utilities/media-query.js
function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}
function mediaQueryListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).addEventListener("change", func);
}

function debounce(func, wait) {
  let timeout;
  return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

class SubscribePicker extends HTMLElement {
  constructor() {
    super();
    this.optionSelectors = Array.from(this.querySelectorAll("[data-subscribe-selector]"));
    this.optionSelectorsVariants = Array.from(document.querySelectorAll(".subscription-variants"));
    this.subscribeInput = document.querySelector('input[name="selling_plan"]');
  }
  connectedCallback() {
    this.optionSelectorsVariants.forEach((optionSelector) => {
      if(optionSelector.querySelector('input').checked){
      this.loadSubscriptions(optionSelector.querySelector('input'));
      }
      optionSelector.querySelector('input').addEventListener("change", this.loadSubscriptions.bind(this));
      if(optionSelector.querySelector('select')){
      optionSelector.querySelector('select').addEventListener("change", this.loadSubscriptionsDropdown.bind(this));
      }
    });
  }
  loadSubscriptions(e) {
    var _this = this;
    if (e.target != null) {
      var subscribeId = e.target.getAttribute('data-subscription');
      if(subscribeId != ''){
      _this.subscribeInput.value = subscribeId;
      _this.changeSubscriptionUrl(subscribeId);}else{
      _this.disableSubsription();
      }
    } else if(e != null){
      var subscribeId = e.getAttribute('data-subscription');
      if(subscribeId != ''){
      _this.subscribeInput.value = subscribeId;
      _this.changeSubscriptionUrl(subscribeId);
      }else{
      _this.disableSubsription();
      }
    } else {
      _this.disableSubsription();
    }
  }
  loadSubscriptionsDropdown(e) {
    var _this = this;
    if (e.target.value != '') {
      var subscribeId = e.target.value;
      e.target.closest('.subscription-variants').querySelector('input').checked = true;
      _this.subscribeInput.value = subscribeId;
      _this.changeSubscriptionUrl(subscribeId);
    } else {
      e.target.closest('.subscription-variants').querySelector('input').checked = false;
      disableSubsription();
    }
  }
  changeSubscriptionUrl(subscribeId) {
    if (history.pushState) {
      let searchParams = new URLSearchParams(window.location.search);
      if (subscribeId != undefined && subscribeId != '') {
        searchParams.set('selling_plan', subscribeId);
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({
          path: newurl
        }, '', newurl);
      } else {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('selling_plan');
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({
          path: newurl
        }, '', newurl);
      }
    }
  }
  disableSubsription(){
  var _this = this;
  _this.subscribeInput.value = '';
  _this.changeSubscriptionUrl();
  }
};

window.customElements.define("subscribe-picker", SubscribePicker);



class VariantInformation extends HTMLElement {
  constructor() {
    super();
    this.variantInfoContainers = document.querySelectorAll(".variant-information");
    this.variantInfoHolders = document.querySelectorAll("variant-information-inline");
    this.subscribeWidget = document.querySelector('recharge-subscribe-widget');
    this.subscribeInput = document.querySelector('input[name="selling_plan"]');
    this.variantInput = document.querySelector('input[name="id"]');
    this.masterSelector = document.forms[this.getAttribute("form")];
    this.loadVariantInfo();
    document.addEventListener('tab:change', () => this.loadBadgeInfo());



    if (this.variantInput) {
      this.variantInput.addEventListener('change', () => {
        this.loadVariantInfo();
        this.loadBadgeInfo();
      });
    }

    if (Shopify.designMode) {
      this.variantInfoContainers.forEach(VariantInfo => {
        const section = VariantInfo.closest(".shopify-section");
        if (section) {
          section.addEventListener("shopify:section:select", () => {
            this.innerHTML = VariantInfo.innerHTML;
          });
        }
      });
    }
  }

  connectedCallback() {
    // Optionally, load info on connect
    this.loadCurrentVariantInfo(this.subscribeInput.value, this.variantInput.value);
    this.loadBadgeInfo();
  }

  loadVariantInfo() {
    const variantId = this.variantInput?.value;
    const hasSubscription = this.subscribeInput?.value !== '';
    this.variantInfoHolders.forEach(VariantHolder => {
      const holderVariantId = VariantHolder.getAttribute('variant-id');
      const isOnetime = VariantHolder.getAttribute('for-variant')?.includes('onetime');
      if (
        (holderVariantId === variantId && hasSubscription) ||
        (holderVariantId === variantId && !hasSubscription && isOnetime)
      ) {
        VariantHolder.classList.add('variant-transition');
        VariantHolder.style.height = 'auto';
      } else {
        VariantHolder.classList.remove('variant-transition');
        VariantHolder.style.height = '0px';
      }
    });
  }

  loadBadgeInfo() {
    console.log('load badge');
    const variantId = this.variantInput?.value;
    const hasSubscription = this.subscribeInput?.value !== '';
    document.querySelectorAll('.product-badge-hide').forEach(item => item.classList.add('hidden'));
    const badgeId = hasSubscription
      ? `badge-for-variant-${variantId}-subscribe-save`
      : `badge-for-variant-${variantId}`;
    const badge = document.getElementById(badgeId);
    console.log(badgeId);
    console.log(badge);
    if (badge) badge.classList.remove('hidden');
  }

  loadCurrentVariantInfo(subscriptionId, variantId) {
    this.variantInfoContainers.forEach(VariantInfo => {
      const forVariant = VariantInfo.getAttribute('for-variant');
      this.variantInfoHolders.forEach(VariantHolder => {
        if (VariantHolder.getAttribute('for-variant') === forVariant) {
          VariantHolder.innerHTML = VariantInfo.innerHTML;
        }
      });
    });
  }
}

window.customElements.define("variant-information", VariantInformation);


class MasonryGrid extends HTMLElement {
  constructor() {
    super();
    if (matchesMediaQuery("sm-max")) {
    }else{
    new Rellax('.rellax', {center: true});
    }
  }
  connectedCallback() {

  }
};

window.customElements.define("masonry-grid", MasonryGrid);


// js/common/navigation/tabs.js
import { Delegate as Delegate10, timeline as timeline6 } from "vendor";
var _componentID, _buttonss, _panelss, _delegate4, _setupComponent, setupComponent_fn, _onButtonClicked, onButtonClicked_fn, _onSlotChange, onSlotChange_fn, _handleKeyboard, handleKeyboard_fn;
var VTabs = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _setupComponent);
    __privateAdd(this, _onButtonClicked);
    __privateAdd(this, _onSlotChange);
    /**
     * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
     * left and right arrow should switch the tab
     */
    __privateAdd(this, _handleKeyboard);
    __privateAdd(this, _componentID, crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
    __privateAdd(this, _buttonss, []);
    __privateAdd(this, _panelss, []);
    __privateAdd(this, _delegate4, new Delegate10(this));
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = __privateGet(this, _buttonss).indexOf(event.target));
    }
    __privateGet(this, _delegate4).on("click", 'button[role="tab"]', __privateMethod(this, _onButtonClicked, onButtonClicked_fn).bind(this));
    this.shadowRoot.addEventListener("slotchange", __privateMethod(this, _onSlotChange, onSlotChange_fn).bind(this));
    this.addEventListener("keydown", __privateMethod(this, _handleKeyboard, handleKeyboard_fn));
  }
  static get observedAttributes() {
    return ["selected-index"];
  }
  connectedCallback() {
    __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
    this.selectedIndex = this.selectedIndex;
  }
  disconnectedCallback() {
    __privateGet(this, _delegate4).destroy();
  }
  /**
   * --------------------------------------------------------------------------
   * GETTERS AND SETTERS
   * --------------------------------------------------------------------------
   */
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.3;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), __privateGet(this, _buttonss).length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
  }
  /**
   * --------------------------------------------------------------------------
   * METHODS
   * --------------------------------------------------------------------------
   */
  attributeChangedCallback(name, oldValue, newValue) {
    __privateGet(this, _buttonss).forEach((button, index) => {
    if(button != null){
    button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false")
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this.transition(__privateGet(this, _panelss)[parseInt(oldValue)], __privateGet(this, _panelss)[parseInt(newValue)]);
    }}
  });
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async transition(fromPanel, toPanel) {
    const beforeWidth = this.clientWidth;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    if (matchesMediaQuery("sm-max")) {
    await timeline6([
      [toPanel, { height: ["0%", "100%"]}, { duration: 1}]
    ]).finished;
    this.style.removeProperty("height");
  }else{
    await timeline6([
      [toPanel, { width: ["0%", "100%"]}, { duration: 1}]
      ]).finished;  
    }
    this.style.removeProperty("width");
  }
};
_componentID = new WeakMap();
_buttonss = new WeakMap();
_panelss = new WeakMap();
_delegate4 = new WeakMap();
_setupComponent = new WeakSet();
setupComponent_fn = function() {
  const contentOnly = Array.from(this.shadowRoot.querySelector('slot[name="tab"]').assignedNodes(), (item) => item.matches("div") && item || item.querySelector("div"))
  .filter(item => item !== null);
  const buttonsOnly = Array.from(this.shadowRoot.querySelector('slot[name="tab"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"))
  .filter(item => item !== null);
  __privateSet(this, _buttonss, buttonsOnly);
  __privateSet(this, _panelss, contentOnly);
  __privateGet(this, _buttonss).forEach((button, index) => {
    if(button != null){
    button.setAttribute("role", "tab");
    button.setAttribute("aria-controls", `tab-panel-${__privateGet(this, _componentID)}-${index}`);
    button.id = `tab-${__privateGet(this, _componentID)}-${index}`;}
  });
  __privateGet(this, _panelss).forEach((panel, index) => {
    if(panel != null){
    panel.setAttribute("role", "tabpanel");
    panel.setAttribute("aria-labelledby", `tab-${__privateGet(this, _componentID)}-${index}`);
    panel.id = `tab-panel-${__privateGet(this, _componentID)}-${index}`;
    panel.hidden = index !== this.selectedIndex;}
  });
  this.style.setProperty("--item-count", __privateGet(this, _buttonss).length.toString());
};
_onButtonClicked = new WeakSet();
onButtonClicked_fn = function(event, button) {
  this.selectedIndex = __privateGet(this, _buttonss).indexOf(button);
};
_onSlotChange = new WeakSet();
onSlotChange_fn = function() {
  __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
};
_handleKeyboard = new WeakSet();
handleKeyboard_fn = function(event) {
  const index = __privateGet(this, _buttonss).indexOf(document.activeElement);
  if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
    return;
  }
  if (event.key === "ArrowLeft") {
    this.selectedIndex = (this.selectedIndex - 1 + __privateGet(this, _buttonss).length) % __privateGet(this, _buttonss).length;
  } else {
    this.selectedIndex = (this.selectedIndex + 1 + __privateGet(this, _buttonss).length) % __privateGet(this, _buttonss).length;
  }
  __privateGet(this, _buttonss)[this.selectedIndex].focus();
};
if (!window.customElements.get("v-tabs")) {
  window.customElements.define("v-tabs", VTabs);
}

// js/common/overlay/modal.js 
import { Modal } from "theme";
import { animate as animate5 } from "vendor";
var ModalInline = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue); // Call the base class method

    if (name === 'open') {
      if(newValue === ''){
        animate5(this.closest('.ingredients'), {minHeight:[0, this.scrollHeight + 'px'] },{ duration: 0.2})
      }else{
        this.closest('.ingredients').style.minHeight = 'auto';
      }
    }
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "modal-inline-template";
  }
  get shouldLock() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get open() {
    return this.hasAttribute("open");
  }
  createEnterAnimationControls() {
  return animate5(this, { opacity: [0, 1] }, { duration: 0.2 });

  }
  createLeaveAnimationControls() {
  return animate5(this, { opacity: [1, 0] }, { duration: 0.2 }); 
  }
};
if (!window.customElements.get("inline-modal")) {
  window.customElements.define("inline-modal", ModalInline);
}



// js/common/navigation/tabs.js
import { Delegate as Delegate5, animate as animate10, timeline as timeline10 } from "vendor";
var _componentID, _buttons, _panels, _delegate4, _setupComponent, setupComponent_fn, _onButtonClicked, onButtonClicked_fn, _onSlotChange, onSlotChange_fn, _handleKeyboard, handleKeyboard_fn;
var InlineTabs = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _setupComponent);
    __privateAdd(this, _onButtonClicked);
    __privateAdd(this, _onSlotChange);
    /**
     * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
     * left and right arrow should switch the tab
     */
    __privateAdd(this, _handleKeyboard);
    __privateAdd(this, _componentID, crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
    __privateAdd(this, _buttons, []);
    __privateAdd(this, _panels, []);
    __privateAdd(this, _delegate4, new Delegate5(this));
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = __privateGet(this, _buttons).indexOf(event.target));
    }
    __privateGet(this, _delegate4).on("click", 'button[role="tab"]', __privateMethod(this, _onButtonClicked, onButtonClicked_fn).bind(this));
    this.shadowRoot.addEventListener("slotchange", __privateMethod(this, _onSlotChange, onSlotChange_fn).bind(this));
    this.addEventListener("keydown", __privateMethod(this, _handleKeyboard, handleKeyboard_fn));
  }
  static get observedAttributes() {
    return ["selected-index"];
  }
  connectedCallback() {
    __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
    this.selectedIndex = this.selectedIndex;
  }
  disconnectedCallback() {
    __privateGet(this, _delegate4).destroy();
  }
  /**
   * --------------------------------------------------------------------------
   * GETTERS AND SETTERS
   * --------------------------------------------------------------------------
   */
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.3;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), __privateGet(this, _panels).length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
  }
  /**
   * --------------------------------------------------------------------------
   * METHODS
   * --------------------------------------------------------------------------
   */
  attributeChangedCallback(name, oldValue, newValue) {
    __privateGet(this, _buttons).forEach((button) => button.setAttribute("aria-selected", button.getAttribute('select-index') == newValue ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this.transition(__privateGet(this, _panels)[parseInt(oldValue)], __privateGet(this, _panels)[parseInt(newValue)]);
    }
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
   async transition(fromPanel, toPanel) {
    const beforeHeight = this.clientHeight;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await timeline6([
      [this, { height: [`${beforeHeight}px`, `${this.clientHeight}px`], overflow: ["hidden", "visible"] }, { duration: 0, easing: [0.85, 0, 0.15, 1] }],
      [toPanel, { opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }]
    ]).finished;
    await animate10(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    this.style.removeProperty("height");
  }
};
_componentID = new WeakMap();
_buttons = new WeakMap();
_panels = new WeakMap();
_delegate4 = new WeakMap();
_setupComponent = new WeakSet();
setupComponent_fn = function() {
  __privateSet(this, _buttons, Array.from(this.querySelectorAll('button.tab-selector')));
  __privateSet(this, _panels, Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes()));
  __privateGet(this, _panels).forEach((panel, index) => {
    var buttons = panel.querySelectorAll('button.tab-selector')
    var button_index = index;
    buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("select-index", index);
      button.setAttribute("aria-controls", `tab-panel-${__privateGet(this, _componentID)}-${index}`);
      button.id = `button-${__privateGet(this, _componentID)}-${index}-${button_index}`;
    });
    panel.setAttribute("role", "tabpanel");
    panel.setAttribute("aria-labelledby", `tab-${__privateGet(this, _componentID)}-${index}`);
    panel.id = `tab-panel-${__privateGet(this, _componentID)}-${index}`;
    panel.hidden = index !== this.selectedIndex;
  });
  this.style.setProperty("--item-count", __privateGet(this, _buttons).length.toString());
};
_onButtonClicked = new WeakSet();
onButtonClicked_fn = function(event, button) {
  this.selectedIndex = button.getAttribute('select-index');
};
_onSlotChange = new WeakSet();
onSlotChange_fn = function() {
  __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
};
_handleKeyboard = new WeakSet();
handleKeyboard_fn = function(event) {
  const index = __privateGet(this, _buttons).indexOf(document.activeElement);
  if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
    return;
  }
  if (event.key === "ArrowLeft") {
    this.selectedIndex = (this.selectedIndex - 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length;
  } else {
    this.selectedIndex = (this.selectedIndex + 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length;
  }
  __privateGet(this, _buttons)[this.selectedIndex].focus();
};
if (!window.customElements.get("inline-tabs")) {
  window.customElements.define("inline-tabs", InlineTabs);
}

import { animate as animate20, timeline as timeline20 } from "vendor";
class TabsWithMedia extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('details');
    this.media = this.querySelectorAll('.media-panel');
    this.style.minHeight = this.media[0].clientHeight + 'px';
  }
  connectedCallback() {
    this.tabs.forEach((details, index) => {
      details.setAttribute('select-index', index);
      details.addEventListener("click", e => {
        this.closeOthers(e);
        this.openMedia(e);
      });
    });
  }
  disconnectedCallback() {
    this.tabs.forEach((details) => {
      details.removeEventListener("click");
    });
  }
  /**
   * --------------------------------------------------------------------------
   * GETTERS AND SETTERS
   * --------------------------------------------------------------------------
   */
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.3;
  }
  closeOthers(e){
    this.tabs.forEach((details, index) => {
    if(details != e.target.closest('details')){
    details.setAttribute('aria-expanded', false);  
    }
    });
  }
  openMedia(e){
    var oldValue = this.selectedIndex;
    var newValue = e.target.closest('details').getAttribute('select-index');
    if (oldValue !== null && oldValue !== newValue) {
      this.selectedIndex = newValue;
      this.transition(this.media[parseInt(newValue)]);
    }   
  }
  async transition(toPanel) {
    var image1 = toPanel.querySelector('.img-one');
    var image2 = toPanel.querySelector('.img-two');
    toPanel.hidden = false;
    toPanel.parentNode.style.minHeight = toPanel.clientHeight + 'px';
    this.media.forEach(media =>{
      if(media != toPanel){
      animate20(media, { zIndex: [1, 0] }, { duration: this.animationDuration });
      }  
      });
    timeline20([
      [toPanel, { zIndex: [0, 1], opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }],
      [image1, { transform: ["translateX(50px)", "translateX(0px)"], opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }],
      [image2, { transform: ["translateX(-50px)", "translateX(0px)"], opacity: [0, 1] }, { duration: this.animationDuration, at: "+0.1" }],
    ]);
    this.media.forEach(media =>{
      if(media != toPanel){
      animate20(media, { opacity: [1, 0] }, { duration: this.animationDuration });
      media.hidden = true;
      }  
      });
  }  
};

window.customElements.define("tabs-with-media", TabsWithMedia);

import { Tabs } from "//lumitylife.co.uk/cdn/shop/t/217/assets/theme.js?v=137930930310090246221769787476";
class TabsLumity extends Tabs {
  constructor() {
    super(); // always call super() first in the constructor. This also calls the extended class' constructor.
    this.isTransitioning = false; // Flag to prevent multiple transitions
    this.masterSelector = document.forms[this.getAttribute("form")];
  }

  connectedCallback() {
    super.connectedCallback(); // Call the parent class's connected
  }

  async transition(fromPanel, toPanel) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    let subscriptions_available = toPanel.querySelectorAll('.subscription-variants-selected');
    if (subscriptions_available.length != 0) {
      subscriptions_available[0].querySelector('label').click();
      this.masterSelector.dispatchEvent(new CustomEvent("tab:change", {
        bubbles: true
      }));
      let container = subscriptions_available[0].querySelector('variant-information-inline');
      if (container) {
        // Apply the transition class and set the height
        container.style.height = 'auto';
      }
    // Removed unused variables beforeHeight and toPanelHeight
    const toPanelHeight = toPanel.scrollHeight;

    fromPanel.hidden = true;
    toPanel.hidden = false;

    // Set initial height for smooth transition
    toPanel.style.height = '0px';
    toPanel.style.overflow = 'hidden';


    // Remove inline styles after transition
    this.style.removeProperty("height");
    toPanel.style.removeProperty("height");
    toPanel.style.removeProperty("overflow");

    this.isTransitioning = false;
  }
  }
};
customElements.define('x-tabs-lumity', TabsLumity);


class AccordionDisclosureGroup extends HTMLElement {
  constructor() {
    super(); // always call super() first in the constructor. This also calls the extended class' constructor.
    this.accordions = this.querySelectorAll('details');
  }
  connectedCallback() {
    this.accordions.forEach((details) => {
      details.addEventListener("click", this.closeOthers.bind(this), true);
    });
  }
  disconnectedCallback() {
    if(this.accordions){
    this.accordions.forEach((details) => {
      details.removeEventListener("click", this.closeOthers.bind(this), true);
    });
    }
  }
  closeOthers(e){
  var _this = this;
  _this.accordions.forEach((details) => {
  if(details != e.target.closest('details')){
  details.setAttribute('aria-expanded', false);  
  }
  if(details == e.target.closest('details') && e.target.closest('details').hasAttribute('aria-expanded="true"')){
  details.setAttribute('aria-expanded', false);
  }
  });
  }
};
customElements.define("accordion-group", AccordionDisclosureGroup);



class TruncateTextComponent extends HTMLElement {
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: 'open' });
    this._fullText = this.textContent.trim();
    this._maxCharsMobile = parseInt(this.getAttribute('max-chars-mobile')) || 0;
    this._maxCharsDesktop = parseInt(this.getAttribute('max-chars-desktop')) || 0;

    if ((matchesMediaQuery("sm-max") && this._maxCharsMobile > 0) ||
    (!matchesMediaQuery("sm-max") && this._maxCharsDesktop > 0)) {
  if (this._fullText.length > (matchesMediaQuery("sm-max") ? this._maxCharsMobile : this._maxCharsDesktop)) {
    this._truncatedText = this._fullText.substring(0, (matchesMediaQuery("sm-max") ? this._maxCharsMobile : this._maxCharsDesktop));
    this._isOpen = false;
    this.createTruncate();
  } else {
    this._isOpen = true;
    this.createTruncateWithoutButton();
  }
} else {
  this._isOpen = true;
  this.createTruncateWithoutButton();
}
  }

  createTruncate() {
    this._shadowRoot.innerHTML = `
      <style>
        .toggleBtn {
          cursor: pointer;
          text-decoration: underline;
        }
      </style>
      <span class="textContainer">${this._isOpen ? this._fullText : this._truncatedText}</span>
      <span class="toggleBtn">${this._isOpen ? 'Read Less' : 'Read More'}</span>
    `;

    this._textContainer = this._shadowRoot.querySelector('.textContainer');
    this._toggleBtn = this._shadowRoot.querySelector('.toggleBtn');

    this._toggleBtn.addEventListener('click', () => this.toggleContent());
  }

  toggleContent() {
    this._isOpen = !this._isOpen;
    this._textContainer.textContent = this._isOpen ? this._fullText : this._truncatedText;
    this._toggleBtn.textContent = this._isOpen ? 'Read Less' : 'Read More';
  }
  createTruncateWithoutButton() {
    this._shadowRoot.innerHTML = `
      <span class="textContainer">${this._fullText}</span>
    `;
    this._textContainer = this._shadowRoot.querySelector('.textContainer');
  }
}

customElements.define('truncate-text-component', TruncateTextComponent);

class YesNoComponent extends HTMLElement {
  constructor() {
    super();
    // Initial state: no buttons are shown
    this.showButtons = false;
    this.submitFormHandler = this.submitForm.bind(this);
    this.checkInputs();
    this.checkTerms();
  }

  // Function to check if both Yes and No inputs are clicked
  checkInputs() {
    this.inputs = Array.from(this.querySelectorAll('input[type="radio"][value="Yes"]'));
    const buttonsDivYes = this.querySelector('.show-button-yes');
    const buttonsDivNo = this.querySelector('.show-button-no');

    if (this.inputs.every(input => input.checked == true )) {
      buttonsDivYes.style.display = 'block';
      buttonsDivNo.style.display = 'none';
    } else {
      buttonsDivYes.style.display = 'none';
      buttonsDivNo.style.display = 'block';
    }
  }
  checkTerms() {
    this.inputs = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    const buttonsDivYes = this.querySelector('.show-button-yes a');
    const buttonsDivNo = this.querySelector('.show-button-no a');
    if (this.inputs.every(input => input.checked == true )) {
      buttonsDivYes.addEventListener('click', this.submitFormHandler);
      buttonsDivNo.addEventListener('click', this.submitFormHandler);  
      buttonsDivYes.classList.remove('disabled');
      buttonsDivNo.classList.remove('disabled');
    } else {
      buttonsDivYes.removeEventListener('click', this.submitFormHandler);
      buttonsDivNo.removeEventListener('click', this.submitFormHandler);  
      buttonsDivYes.classList.add('disabled');
      buttonsDivNo.classList.add('disabled');
    }
  }

  // Lifecycle method called when the element is connected to the DOM
  submitForm(){ 
  event.preventDefault();
  let redirect_url = event.target.href;
  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
    window.location.href = redirect_url;
    }
  });
  this.querySelector('form.klaviyo-form button.go156862118').click();
  }
  connectedCallback() {
    const buttonsDivYes = this.querySelector('.show-button-yes');
    const buttonsDivNo = this.querySelector('.show-button-no');
    const radioInputs = this.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(input => {
      input.addEventListener('change', this.checkInputs.bind(this));
    });
    const checkboxInputs = this.querySelectorAll('input[type="checkbox"]');
    checkboxInputs.forEach(input => {
      input.addEventListener('change', this.checkTerms.bind(this));
    });
  }

  // Lifecycle method called when the element is disconnected from the DOM
  disconnectedCallback() {
    const radioInputs = this.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(input => {
      input.addEventListener('change', this.checkInputs.bind(this));
    });
  }
}

// Define the custom element and register it with the custom tag name
customElements.define('yes-no-component', YesNoComponent);

import { ImageWithText } from "theme";
var ValueForMoney = class extends ImageWithText {
  constructor() {
    super();
  }
};
if (!window.customElements.get("value-for-money")) {
  window.customElements.define("value-for-money", ValueForMoney);
}
import { EffectCarousel } from "theme";

gsap.registerPlugin(ScrollTrigger);

class ClinicalTrials extends HTMLElement {
  constructor() {
    super();
    this.setupScrollTrigger();
  }

  connectedCallback() {
  }
  setupScrollTrigger(){

    // Pin the section using GSAP
    let headerHeight = Number(document.querySelector('header').offsetHeight) + Number(document.querySelector('.shopify-section-group-header-group').offsetHeight)
    let startTrigger = "top " + headerHeight + "px";
    if(matchesMediaQuery("sm-max")){
    var scroll_time = "+=1000";
    }
    if(matchesMediaQuery("sm")){
    var scroll_time = "+=1500";
    }
    let tl = gsap.timeline({
      // yes, we can add it to an entire timeline!
      scrollTrigger: {
          trigger: this,
          pin: this, // pin the trigger element while active
          pinSpacing: true,
          start: startTrigger, // when the top of the trigger hits the top of the viewport
          end: scroll_time, // end after scrolling 500px beyond the start
          markers: true,
          smoothChildTiming: true,
          scrub: 0, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
          onUpdate: (self) => console.log("progress:", self.progress)
      }
  });
  
  // add animations and labels to the timeline
  let scrollableHeight = this.querySelector('.scrollable-content').scrollHeight;
  let containerHeight = this.querySelector('.clinical-trial-scroll__container').clientHeight;
  let totalScrollablePixels = scrollableHeight - containerHeight + 50;
  tl.fromTo('.clinical-trial-scroll__container', { scrollTop: 0 }, { scrollTop: totalScrollablePixels });
  }
}

if (!window.customElements.get("clinical-trials")) {
  window.customElements.define("clinical-trials", ClinicalTrials);
}

(function () {
  const SCOPE_SELECTOR = '.js-price-toggle-scope[data-show-price-variants]';

  // Adjust this if your theme uses a different price wrapper class
  const PRICE_SELECTORS = [
    '.price',                 // common
    '.product-price',         // common
    '[data-price]',           // common
    '[data-product-price]',   // common
    '.show-hide-single-price'             // Prestige-ish
  ];

  function parseAllowed(scope) {
    return new Set(
      (scope.getAttribute('data-show-price-variants') || '')
        .split(',')
        .map(s => Number(s.trim()))
        .filter(n => Number.isFinite(n))
    );
  }

  function getVariantId() {
    const input =
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action^="/cart/add"] select[name="id"]') ||
      document.querySelector('input[name="id"]:checked');

    if (input?.value) return Number(input.value);

    const v = new URL(location.href).searchParams.get('variant');
    return v ? Number(v) : null;
  }

  function findPriceEl(scope) {
    for (const sel of PRICE_SELECTORS) {
      const el = scope.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function update() {
    document.querySelectorAll(SCOPE_SELECTOR).forEach(scope => {
      const allowed = parseAllowed(scope);
      const vid = getVariantId();

      const priceEl = findPriceEl(scope);
      if (!priceEl) return; // if we can't find it, don't break anything

      const shouldShow = vid != null && allowed.has(vid);
      priceEl.style.display = shouldShow ? '' : 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', update);

  document.addEventListener('change', (e) => {
    if (e.target.closest('form[action^="/cart/add"], variant-selects, variant-radios, [data-variant-picker]')) {
      requestAnimationFrame(update);
      setTimeout(update, 0);
    }
  });

  // Catch Prestige re-renders
  new MutationObserver(update).observe(document.documentElement, { childList: true, subtree: true });

  // Catch URL updates
  window.addEventListener('popstate', update);
})();